<div class="portalnav-wrap por-ac-contracts">
    @if ((appFacadeService.getSubActiveTab() | async) !== 'ContractDetail') {
    <div class="wrapper contract-headingSection">
        <h2>{{ 'Contract List for' | translate }} {{ customer?.Name }}</h2>
        @if (versionToggle.isAdvanceVersion()) {
        <span>{{ 'contractTabInfoText' | translate }}.</span>
        }
    </div>
    }

    <div class="portalnav wrapper" [ngStyle]="{ height: height, width: width }">
        @if (appFacadeService.getSubActiveTab() | async; as tab) {
        <div class="main-contract-page">
            <div [hidden]="tab !== 'Default'">
                <ng-container [ngTemplateOutlet]="contracts"></ng-container>
            </div>
            <div [hidden]="tab !== 'ContractDetail'">
                <ng-container [ngTemplateOutlet]="contractDetailTab"></ng-container>
            </div>
        </div>
        }
    </div>
</div>
<ng-template #contracts>
    <div class="contract-wrapper">
        <div class="date-range" [ngClass]="{ paymentButtonVisible: isMultipaymentAvailable() }">
            <por-filters
                [multiFilters]="filterValues"
                [initFilters]="statusFilters()"
                [isProcessing]="(appFacadeService.getLoader() | async) || false"
                [searchPlaceholder]="filterComponentProps.searchPlaceHolder"
                [dateLabel]="filterComponentProps.dateLabel"
                [startDateLabel]="'FromStartDate'"
                [endDateLabel]="'ToEndDate'"
                [startDateLabelMobile]="'FromStartDate'"
                [endDateLabelMobile]="'ToEndDate'"
                (filterOutput)="filter($any($event))"
                [disableSearch]="!isSearchSupported"
                (exportCSV)="exportCSV()"
                [enableExport]="$any(contracts$ | async | count) > 0"
                [exportButtonEnabled]="selectedContracts.length === 0"
                [uiUrl]="uiUrl"></por-filters>

            @if (isMultipaymentAvailable()) {
            <div class="contract-payment-button">
                @if (selectedContracts.length === 0) {
                <por-base-button (click)="filterClosedContract()" [theme]="'primary'" [featureName]="'payment-toggle-button'" class="split-button ml-625">
                    <por-pay-icon-text [label]="'PayMultiple'" [checked]="payMultipleClicked()"></por-pay-icon-text>
                </por-base-button>
                } @if (selectedContracts.length > 0) {
                <por-base-button
                    #payMultipleContractPanelTrigger="cdkOverlayOrigin"
                    cdkOverlayOrigin
                    (click)="toggleOverlay(true)"
                    [theme]="'primary'"
                    [featureName]="'payment-button'"
                    class="split-button ml-625">
                    <por-base-mat-badge [badgeContent]="selectedContracts.length" [isHidden]="selectedContracts.length === 0" badgeColor="warn"></por-base-mat-badge>
                    <por-pay-icon-text [label]="'PayMultiple'" [checked]="payMultipleClicked()"></por-pay-icon-text>
                </por-base-button>
                <por-multi-payment-contract-panel [isOpen]="overlayStates" [trigger]="payMultipleContractPanelTrigger" (closeOverlay)="toggleOverlay(false)"></por-multi-payment-contract-panel>
                }
            </div>
            }
        </div>

        <div class="content-wrapper" porAddFeature featureName="aggridheader">
            <div class="title-wrapper">
                <ng-template #disableMultiplePaymentText>
                    <span class="click-title theme-paragraph">{{ 'Click a contract# link to view contract details' | translate }}</span>
                </ng-template>
                <ng-template porFeatureAvailability [featureToken]="['multiplePaymentAbility']" [fallbackTemplate]="disableMultiplePaymentText">
                    <por-contract-instructions></por-contract-instructions>
                </ng-template>

                @if (appFacadeService.getSelectedContractsTotal() | async; as total) {
                <ng-template porFeatureAvailability [featureToken]="['Account.SeePricing']">
                    <div class="click-title total-contracts">{{ 'TotalSelectedContracts' | translate }}: {{ total | formatCurrency }}</div>
                </ng-template>
                }
            </div>
            @if ((gridReadyObservable$ | async) && (appFacadeService.isAccountFeaturesLoaded() | async)) {
            <ag-grid-angular
                class="ag-theme-alpine ag-grid"
                g-grid-angular
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [rowSelection]="rowSelection"
                [suppressRowClickSelection]="true"
                [rowData]="contracts$ | async"
                [animateRows]="true"
                [rowHeight]="rowHeight"
                [headerHeight]="headerHeight"
                (gridReady)="onGridReady($event)"
                (cellDoubleClicked)="onCellDoubleClicked($event)"
                [isFullWidthRow]="isFullWidthRow"
                [fullWidthCellRenderer]="fullWidthCellRenderer"
                [context]="context"></ag-grid-angular>
            }
        </div>
        <div class="middle">
            <por-load-more [hasMoreRecord]="(isRecordAvaible$ | async) ?? false" [featureName]="'load-more-contracts'" (loadMore)="loadMore()"></por-load-more>
        </div>
    </div>
</ng-template>

<ng-template #contractDetailTab>
    @if (appFacadeService.getContractDetail() | async; as contractDetail) {
    <div class="contract-detail">
        @if (contractDetail) {
        <por-contract-detail
            (closePanel)="onClosePanelContractDetail()"
            [customerId]="customerId"
            [contractDetail]="[contractDetail]"
            [openForPayment]="amountDueClicked()"
            [uiUrl]="inputs?.uiUrl"
            (reloadContract)="reloadContract($event)"
            (reloadContractList)="contractlist.next(true)"></por-contract-detail>
        }
    </div>
    }
</ng-template>

<por-base-modal [id]="'payment-modal'" [modalWidth]="'modal-lg'" (onclose)="onPaymentClose()">
    <por-multipayment></por-multipayment>
</por-base-modal>

<por-payment-success-dialog></por-payment-success-dialog>
<por-request-sent-successfully-dialog></por-request-sent-successfully-dialog>
